import { render, staticRenderFns } from "./rectificationNotice.vue?vue&type=template&id=21948f4c&scoped=true&"
import script from "./rectificationNotice.vue?vue&type=script&lang=ts&"
export * from "./rectificationNotice.vue?vue&type=script&lang=ts&"
import style0 from "./rectificationNotice.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./rectificationNotice.vue?vue&type=style&index=1&id=21948f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21948f4c",
  null
  
)

export default component.exports